export const JWPLAYER_SCRIPT_URL = 'https://cdn.jwplayer.com/libraries/2nAPZnzC.js';
